'use strict';

const actions = {};

export default actions;
